const STATUS_MESSAGES = Object.freeze({
  loading: 'Loading the interactive tool…',
  ready: 'The interactive tool is ready.',
  invalidConfig: 'This tool is not configured correctly. Please try again later.',
  unknownTool: 'This tool is not available in this workspace yet.',
  loadFailed: 'The interactive tool could not be loaded. Please try again later.',
});

export const RUNTIME_ALLOWLIST = Object.freeze({
  'base64-encoder-decoder': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-base64-encoder-decoder',
    load: () => import('./aigclub-tool-runtime-base64-encoder-decoder.js?v=stage02-session05-v1'),
  }),
  'url-encoder-decoder': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-url-encoder-decoder',
    load: () => import('./aigclub-tool-runtime-url-encoder-decoder.js?v=stage02-session05-v1'),
  }),
  'json-formatter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-json-formatter',
    load: () => import('./aigclub-tool-runtime-json-formatter.js?v=stage02-session05-v1'),
  }),
  'unix-timestamp-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-unix-timestamp-converter',
    load: () => import('./aigclub-tool-runtime-unix-timestamp-converter.js?v=stage02-session05-v1'),
  }),
  'html-entity-encoder-decoder': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-html-entity-encoder-decoder',
    load: () => import('./aigclub-tool-runtime-html-entity-encoder-decoder.js?v=stage02-session05-v1'),
  }),
  'json-minifier': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-json-minifier',
    load: () => import('./aigclub-tool-runtime-json-minifier.js?v=stage02-session05-v1'),
  }),
  'uuid-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-uuid-generator',
    load: () => import('./aigclub-tool-runtime-uuid-generator.js?v=stage02-session05-v1'),
  }),
  'jwt-decoder': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-jwt-decoder',
    load: () => import('./aigclub-tool-runtime-jwt-decoder.js?v=stage02-session05-v1'),
  }),
  'xml-formatter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-xml-formatter',
    load: () => import('./aigclub-tool-runtime-xml-formatter.js?v=stage02-session05-v1'),
  }),
  'yaml-formatter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-yaml-formatter',
    load: () => import('./aigclub-tool-runtime-yaml-formatter.js?v=stage02-session05-v1'),
  }),
  'toml-formatter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-toml-formatter',
    load: () => import('./aigclub-tool-runtime-toml-formatter.js?v=stage02-session05-v1'),
  }),
  'csv-to-json-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-csv-to-json-converter',
    load: () => import('./aigclub-tool-runtime-csv-to-json-converter.js?v=stage02-session05-v1'),
  }),
  'json-to-csv-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-json-to-csv-converter',
    load: () => import('./aigclub-tool-runtime-json-to-csv-converter.js?v=stage02-session05-v1'),
  }),
  'query-string-parser': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-query-string-parser',
    load: () => import('./aigclub-tool-runtime-query-string-parser.js?v=stage02-session05-v1'),
  }),
  'http-status-code-reference': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-http-status-code-reference',
    load: () => import('./aigclub-tool-runtime-http-status-code-reference.js?v=stage02-session05-v1'),
  }),
  'cron-expression-parser': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-cron-expression-parser',
    load: () => import('./aigclub-tool-runtime-cron-expression-parser.js?v=stage02-session05-v1'),
  }),
  'regex-tester': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-regex-tester',
    load: () => import('./aigclub-tool-runtime-regex-tester.js?v=stage02-session05-v1'),
  }),
  'markdown-table-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-markdown-table-generator',
    load: () => import('./aigclub-tool-runtime-markdown-table-generator.js?v=stage02-session04-a11y1'),
  }),
  'html-minifier': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-html-minifier',
    load: () => import('./aigclub-tool-runtime-html-minifier.js?v=stage02-session05-v1'),
  }),
  'css-minifier': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-css-minifier',
    load: () => import('./aigclub-tool-runtime-css-minifier.js?v=stage02-session05-v1'),
  }),
  'javascript-beautifier': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-javascript-beautifier',
    load: () => import('./aigclub-tool-runtime-javascript-beautifier.js?v=stage02-session05-v1'),
  }),
  'url-parser': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-url-parser',
    load: () => import('./aigclub-tool-runtime-url-parser.js?v=stage02-session05-v1'),
  }),
  'jsonpath-tester': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-jsonpath-tester',
    load: () => import('./aigclub-tool-runtime-jsonpath-tester.js?v=stage02-session05-v1'),
  }),
  'percentage-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-percentage-calculator',
    load: () => import('./aigclub-tool-runtime-percentage-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'discount-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-discount-calculator',
    load: () => import('./aigclub-tool-runtime-discount-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'percentage-change-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-percentage-change-calculator',
    load: () => import('./aigclub-tool-runtime-percentage-change-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'average-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-average-calculator',
    load: () => import('./aigclub-tool-runtime-average-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'ratio-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-ratio-calculator',
    load: () => import('./aigclub-tool-runtime-ratio-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'proportion-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-proportion-calculator',
    load: () => import('./aigclub-tool-runtime-proportion-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'percentage-point-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-percentage-point-calculator',
    load: () => import('./aigclub-tool-runtime-percentage-point-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'square-root-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-square-root-calculator',
    load: () => import('./aigclub-tool-runtime-square-root-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'exponent-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-exponent-calculator',
    load: () => import('./aigclub-tool-runtime-exponent-calculator.js?v=stage03-en-lm-01-v1'),
  }),
  'rounding-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-rounding-calculator',
    load: () => import('./aigclub-tool-runtime-rounding-calculator.js?v=stage03-en-lm-02-v1'),
  }),
  'scientific-notation-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-scientific-notation-converter',
    load: () => import('./aigclub-tool-runtime-scientific-notation-converter.js?v=stage03-en-lm-02-v1'),
  }),
  'unit-rate-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-unit-rate-calculator',
    load: () => import('./aigclub-tool-runtime-unit-rate-calculator.js?v=stage03-en-lm-02-v1'),
  }),
  'tip-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-tip-calculator',
    load: () => import('./aigclub-tool-runtime-tip-calculator.js?v=stage03-en-lm-02-v1'),
  }),
  'compound-percentage-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-compound-percentage-calculator',
    load: () => import('./aigclub-tool-runtime-compound-percentage-calculator.js?v=stage03-en-lm-02-v1'),
  }),
  'aspect-ratio-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-aspect-ratio-calculator',
    load: () => import('./aigclub-tool-runtime-aspect-ratio-calculator.js?v=stage03-en-lm-02-v1'),
  }),
  'scale-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-scale-calculator',
    load: () => import('./aigclub-tool-runtime-scale-calculator.js?v=stage03-en-lm-02-v1'),
  }),
  'modulo-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-modulo-calculator',
    load: () => import('./aigclub-tool-runtime-modulo-calculator.js?v=stage03-en-lm-02-v1'),
  }),
  'temperature-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-temperature-converter',
    load: () => import('./aigclub-tool-runtime-temperature-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'length-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-length-converter',
    load: () => import('./aigclub-tool-runtime-length-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'weight-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-weight-converter',
    load: () => import('./aigclub-tool-runtime-weight-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'area-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-area-converter',
    load: () => import('./aigclub-tool-runtime-area-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'data-size-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-data-size-converter',
    load: () => import('./aigclub-tool-runtime-data-size-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'speed-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-speed-converter',
    load: () => import('./aigclub-tool-runtime-speed-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'volume-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-volume-converter',
    load: () => import('./aigclub-tool-runtime-volume-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'color-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-color-converter',
    load: () => import('./aigclub-tool-runtime-color-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'angle-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-angle-converter',
    load: () => import('./aigclub-tool-runtime-angle-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'pressure-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-pressure-converter',
    load: () => import('./aigclub-tool-runtime-pressure-converter.js?v=stage03-en-lm-03-v1'),
  }),
  'energy-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-energy-converter',
    load: () => import('./aigclub-tool-runtime-energy-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'power-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-power-converter',
    load: () => import('./aigclub-tool-runtime-power-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'frequency-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-frequency-converter',
    load: () => import('./aigclub-tool-runtime-frequency-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'fuel-consumption-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-fuel-consumption-converter',
    load: () => import('./aigclub-tool-runtime-fuel-consumption-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'density-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-density-converter',
    load: () => import('./aigclub-tool-runtime-density-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'force-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-force-converter',
    load: () => import('./aigclub-tool-runtime-force-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'torque-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-torque-converter',
    load: () => import('./aigclub-tool-runtime-torque-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'time-unit-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-time-unit-converter',
    load: () => import('./aigclub-tool-runtime-time-unit-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'number-base-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-number-base-converter',
    load: () => import('./aigclub-tool-runtime-number-base-converter.js?v=stage03-en-lm-04-v1'),
  }),
  'word-counter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-word-counter',
    load: () => import('./aigclub-tool-runtime-word-counter.js?v=stage03-en-lm-05-v1'),
  }),
  'case-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-case-converter',
    load: () => import('./aigclub-tool-runtime-case-converter.js?v=stage03-en-lm-05-v1'),
  }),
  'duplicate-line-remover': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-duplicate-line-remover',
    load: () => import('./aigclub-tool-runtime-duplicate-line-remover.js?v=stage03-en-lm-05-v1'),
  }),
  'text-sorter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-text-sorter',
    load: () => import('./aigclub-tool-runtime-text-sorter.js?v=stage03-en-lm-05-v1'),
  }),
  'whitespace-cleaner': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-whitespace-cleaner',
    load: () => import('./aigclub-tool-runtime-whitespace-cleaner.js?v=stage03-en-lm-05-v1'),
  }),
  'line-number-adder': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-line-number-adder',
    load: () => import('./aigclub-tool-runtime-line-number-adder.js?v=stage03-en-lm-05-v1'),
  }),
  'find-replace-tool': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-find-replace-tool',
    load: () => import('./aigclub-tool-runtime-find-replace-tool.js?v=stage03-en-lm-05-v1'),
  }),
  'prefix-suffix-adder': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-prefix-suffix-adder',
    load: () => import('./aigclub-tool-runtime-prefix-suffix-adder.js?v=stage03-en-lm-05-v1'),
  }),
  'text-reverser': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-text-reverser',
    load: () => import('./aigclub-tool-runtime-text-reverser.js?v=stage03-en-lm-06-v1-cdn1'),
  }),
  'list-randomizer': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-list-randomizer',
    load: () => import('./aigclub-tool-runtime-list-randomizer.js?v=stage03-en-lm-06-v1-cdn1'),
  }),
  'comma-separated-list-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-comma-separated-list-converter',
    load: () => import('./aigclub-tool-runtime-comma-separated-list-converter.js?v=stage03-en-lm-06-v1-cdn1'),
  }),
  'slug-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-slug-generator',
    load: () => import('./aigclub-tool-runtime-slug-generator.js?v=stage03-en-lm-06-v1-cdn1'),
  }),
  'character-frequency-counter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-character-frequency-counter',
    load: () => import('./aigclub-tool-runtime-character-frequency-counter.js?v=stage03-en-lm-06-v1-cdn1'),
  }),
  'word-frequency-counter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-word-frequency-counter',
    load: () => import('./aigclub-tool-runtime-word-frequency-counter.js?v=stage03-en-lm-06-v1-cdn1'),
  }),
  'duplicate-word-remover': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-duplicate-word-remover',
    load: () => import('./aigclub-tool-runtime-duplicate-word-remover.js?v=stage03-en-lm-06-v1-cdn1'),
  }),
  'line-filter-tool': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-line-filter-tool',
    load: () => import('./aigclub-tool-runtime-line-filter-tool.js?v=stage03-en-lm-06-v1-cdn1'),
  }),
  'date-add-subtract-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-date-add-subtract-calculator',
    load: () => import('./aigclub-tool-runtime-date-add-subtract-calculator.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'age-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-age-calculator',
    load: () => import('./aigclub-tool-runtime-age-calculator.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'week-number-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-week-number-calculator',
    load: () => import('./aigclub-tool-runtime-week-number-calculator.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'time-diff-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-time-diff-calculator',
    load: () => import('./aigclub-tool-runtime-time-diff-calculator.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'countdown-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-countdown-calculator',
    load: () => import('./aigclub-tool-runtime-countdown-calculator.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'month-difference-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-month-difference-calculator',
    load: () => import('./aigclub-tool-runtime-month-difference-calculator.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'days-until-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-days-until-calculator',
    load: () => import('./aigclub-tool-runtime-days-until-calculator.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'day-of-year-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-day-of-year-calculator',
    load: () => import('./aigclub-tool-runtime-day-of-year-calculator.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'leap-year-checker': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-leap-year-checker',
    load: () => import('./aigclub-tool-runtime-leap-year-checker.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'date-format-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-date-format-converter',
    load: () => import('./aigclub-tool-runtime-date-format-converter.js?v=stage03-en-lm-07-v1-cdn1'),
  }),
  'batch-timestamp-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-batch-timestamp-converter',
    load: () => import('./aigclub-tool-runtime-batch-timestamp-converter.js?v=stage03-en-lm-08-v1'),
  }),
  'date-difference-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-date-difference-calculator',
    load: () => import('./aigclub-tool-runtime-date-difference-calculator.js?v=stage03-en-high-01-v1'),
  }),
  'business-days-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-business-days-calculator',
    load: () => import('./aigclub-tool-runtime-business-days-calculator.js?v=stage03-en-high-01-v1'),
  }),
  'time-zone-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-time-zone-converter',
    load: () => import('./aigclub-tool-runtime-time-zone-converter.js?v=stage03-en-high-01-v1'),
  }),
  'working-hours-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-working-hours-calculator',
    load: () => import('./aigclub-tool-runtime-working-hours-calculator.js?v=stage03-en-high-01-v1'),
  }),
  'hash-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-hash-generator',
    load: () => import('./aigclub-tool-runtime-hash-generator.js?v=stage03-en-high-02-v1'),
  }),
  'hmac-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-hmac-generator',
    load: () => import('./aigclub-tool-runtime-hmac-generator.js?v=stage03-en-high-02-v1'),
  }),
  'sensitive-data-masker': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-sensitive-data-masker',
    load: () => import('./aigclub-tool-runtime-sensitive-data-masker.js?v=stage03-en-high-02-v1'),
  }),
  'json-redactor': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-json-redactor',
    load: () => import('./aigclub-tool-runtime-json-redactor.js?v=stage03-en-high-02-v1'),
  }),
  'fraction-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-fraction-calculator',
    load: () => import('./aigclub-tool-runtime-fraction-calculator.js?v=stage03-en-high-03-v1'),
  }),
  'text-diff-checker': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-text-diff-checker',
    load: () => import('./aigclub-tool-runtime-text-diff-checker.js?v=stage03-en-high-03-v1'),
  }),
  'password-strength-checker': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-password-strength-checker',
    load: () => import('./aigclub-tool-runtime-password-strength-checker.js?v=stage03-en-high-03-v1'),
  }),
  'marketplace-fee-estimator-basic': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-marketplace-fee-estimator-basic',
    load: () => import('./aigclub-tool-runtime-marketplace-fee-estimator-basic.js?v=stage03-en-high-03-v1'),
  }),
  'image-resizer': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-image-resizer',
    load: () => import('./aigclub-tool-runtime-image-resizer.js?v=stage03-en-file-01-v1'),
  }),
  'image-cropper': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-image-cropper',
    load: () => import('./aigclub-tool-runtime-image-cropper.js?v=stage03-en-file-01-v1'),
  }),
  'image-format-converter': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-image-format-converter',
    load: () => import('./aigclub-tool-runtime-image-format-converter.js?v=stage03-en-file-01-v1'),
  }),
  'profit-margin-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-profit-margin-calculator',
    load: () => import('./aigclub-tool-runtime-profit-margin-calculator.js?v=stage03-en-lm-08-v1'),
  }),
  'target-margin-price-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-target-margin-price-calculator',
    load: () => import('./aigclub-tool-runtime-target-margin-price-calculator.js?v=stage03-en-lm-08-v1'),
  }),
  'markup-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-markup-calculator',
    load: () => import('./aigclub-tool-runtime-markup-calculator.js?v=stage03-en-lm-08-v1'),
  }),
  'break-even-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-break-even-calculator',
    load: () => import('./aigclub-tool-runtime-break-even-calculator.js?v=stage03-en-lm-08-v1'),
  }),
  'volumetric-weight-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-volumetric-weight-calculator',
    load: () => import('./aigclub-tool-runtime-volumetric-weight-calculator.js?v=stage03-en-lm-08-v1'),
  }),
  'unit-price-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-unit-price-calculator',
    load: () => import('./aigclub-tool-runtime-unit-price-calculator.js?v=stage03-en-lm-08-v1'),
  }),
  'discount-stack-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-discount-stack-calculator',
    load: () => import('./aigclub-tool-runtime-discount-stack-calculator.js?v=stage03-en-lm-08-v1'),
  }),
  'total-cost-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-total-cost-calculator',
    load: () => import('./aigclub-tool-runtime-total-cost-calculator.js?v=stage03-en-lm-08-v1'),
  }),
  'sku-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-sku-generator',
    load: () => import('./aigclub-tool-runtime-sku-generator.js?v=stage03-en-lm-08-v1'),
  }),
  'password-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-password-generator',
    load: () => import('./aigclub-tool-runtime-password-generator.js?v=stage03-en-lm-09-v1'),
  }),
  'random-string-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-random-string-generator',
    load: () => import('./aigclub-tool-runtime-random-string-generator.js?v=stage03-en-lm-09-v1'),
  }),
  'passphrase-generator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-passphrase-generator',
    load: () => import('./aigclub-tool-runtime-passphrase-generator.js?v=stage03-en-lm-09-v1'),
  }),
  'cookie-parser': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-cookie-parser',
    load: () => import('./aigclub-tool-runtime-cookie-parser.js?v=stage03-en-lm-09-v1'),
  }),
  'checksum-calculator': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-checksum-calculator',
    load: () => import('./aigclub-tool-runtime-checksum-calculator.js?v=stage03-en-lm-09-v1'),
  }),
  'utm-builder': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-utm-builder',
    load: () => import('./aigclub-tool-runtime-utm-builder.js?v=stage03-en-lm-09-v1'),
  }),
  'meta-title-description-preview': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-meta-title-description-preview',
    load: () => import('./aigclub-tool-runtime-meta-title-description-preview.js?v=stage03-en-lm-09-v1'),
  }),
  'robots-txt-tester': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-robots-txt-tester',
    load: () => import('./aigclub-tool-runtime-robots-txt-tester.js?v=stage03-en-lm-09-v1'),
  }),
  'sitemap-url-extractor': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-sitemap-url-extractor',
    load: () => import('./aigclub-tool-runtime-sitemap-url-extractor.js?v=stage03-en-lm-09-v1'),
  }),
  'keyword-list-cleaner': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-keyword-list-cleaner',
    load: () => import('./aigclub-tool-runtime-keyword-list-cleaner.js?v=stage03-en-lm-09-v1'),
  }),
  'stage02-contract-fixture': Object.freeze({
    runtimeEntry: 'aigclub-tool-runtime-contract-fixture',
    load: () => import('./aigclub-tool-runtime-contract-fixture.js'),
  }),
});

const initializationPromises = new WeakMap();

function setStatus(root, state, message) {
  root.dataset.aigclubRuntimeState = state;
  const status = root.querySelector('[data-aigclub-tool-status]');
  if (status) status.textContent = message;
}

export function readToolConfig(root) {
  const configElement = root?.querySelector?.('[data-aigclub-tool-config]');
  if (!configElement) return null;

  try {
    const config = JSON.parse(configElement.textContent || '{}');
    if (
      typeof config.internalId !== 'string'
      || typeof config.toolKey !== 'string'
      || typeof config.categoryKey !== 'string'
      || typeof config.runtimeEntry !== 'string'
      || typeof config.sourceHash !== 'string'
      || typeof config.migrationVersion !== 'string'
      || typeof config.ownershipMarker !== 'string'
      || typeof config.locale !== 'string'
      || !config.internalId
      || !config.toolKey
      || !config.categoryKey
      || !config.runtimeEntry
      || !config.sourceHash
      || !config.migrationVersion
      || !config.ownershipMarker
    ) return null;
    return config;
  } catch {
    return null;
  }
}

export function initializeToolRoot(root, { allowlist = RUNTIME_ALLOWLIST } = {}) {
  if (!root?.querySelector) return Promise.resolve({ state: 'missing-root' });
  if (initializationPromises.has(root)) return initializationPromises.get(root);

  const task = (async () => {
    const config = readToolConfig(root);
    if (!config) {
      setStatus(root, 'error', STATUS_MESSAGES.invalidConfig);
      return { state: 'invalid-config' };
    }

    const allowedRuntime = allowlist[config.toolKey];
    if (!allowedRuntime || allowedRuntime.runtimeEntry !== config.runtimeEntry) {
      setStatus(root, 'error', STATUS_MESSAGES.unknownTool);
      return { state: 'unknown-tool' };
    }

    setStatus(root, 'loading', STATUS_MESSAGES.loading);
    try {
      const runtimeModule = await allowedRuntime.load();
      if (typeof runtimeModule?.mountAigclubTool !== 'function') {
        throw new TypeError('Runtime module does not export mountAigclubTool.');
      }
      await runtimeModule.mountAigclubTool({ root, config, data: config });
      setStatus(root, 'ready', STATUS_MESSAGES.ready);
      return { state: 'ready', toolKey: config.toolKey };
    } catch {
      setStatus(root, 'error', STATUS_MESSAGES.loadFailed);
      return { state: 'load-failed', toolKey: config.toolKey };
    }
  })();

  initializationPromises.set(root, task);
  return task;
}

export function initializeToolPage(documentRoot = globalThis.document, options = {}) {
  if (!documentRoot?.querySelectorAll) return Promise.resolve([]);
  const roots = [...documentRoot.querySelectorAll('[data-aigclub-tool-root]')];
  return Promise.all(roots.map((root) => initializeToolRoot(root, options)));
}

if (globalThis.document) initializeToolPage();
